module.exports = "https://thumbor.subcdn.com/imageView2/minio-activity/engro-cleaner/google-play.18b18ba2.png";